/**
 * @generated SignedSource<<40d5e7859194972a2f32f580ef701809>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptionsQueryRenderer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_viewer" | "checkoutRelayAction_viewer" | "usePreloadedDuties_viewer">;
  readonly " $fragmentType": "CheckoutDeliveryOptionsQueryRenderer_viewer";
};
export type CheckoutDeliveryOptionsQueryRenderer_viewer$key = {
  readonly " $data"?: CheckoutDeliveryOptionsQueryRenderer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptionsQueryRenderer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTransactionQueryRenderer_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutRelayAction_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTransactionReducer_viewer",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chargeCurrencies",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrencyConversionRateEvent",
              "kind": "LinkedField",
              "name": "currentRates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutShippingReducer_viewer",
          "selections": [
            {
              "condition": "hasSessionUserGeoInfo",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RegionalInfo",
                  "kind": "LinkedField",
                  "name": "regionalInfo",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "hasSessionUserGeoInfo"
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreloadedDuties_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d2ebf86f8c613e55d255d8099eb8af7e";

export default node;
